export default __webpack_public_path__ + "static/media/notification2.def67629.mp3";